import { useMemo } from 'react';
import { useBulkFetchSchedules } from '@/features/planner/queries/useBulkFetchSchedules';
import { useGetSchedulesByItemIds } from '@/features/settings/work-integrations/queries/useGetSchedules';
import type { PlanSchedulingScenarioContext } from '../adapters/types';

export interface DependencyForecastDates {
  forecastedStartDateTime: string | null;
  forecastedFinishDateTime: string | null;
}

export const useDependencyForecastDates = (
  itemIds: number[],
  scenarioContext?: PlanSchedulingScenarioContext,
): Record<number, DependencyForecastDates> => {
  const { data: scenarioSchedules } = useBulkFetchSchedules({
    loopId: scenarioContext?.loopId ?? 0,
    scenarioId: scenarioContext?.scenarioId ?? 0,
    itemIds: scenarioContext ? itemIds : [],
  });

  const { data: schedules } = useGetSchedulesByItemIds(
    scenarioContext ? [] : itemIds,
    undefined,
    !scenarioContext,
  );

  return useMemo(() => {
    if (scenarioContext) {
      const forecastByItemId: Record<number, DependencyForecastDates> = {};
      for (const [itemId, schedule] of Object.entries(scenarioSchedules ?? {})) {
        forecastByItemId[Number(itemId)] = {
          forecastedStartDateTime: schedule.forecastedStartDateTime,
          forecastedFinishDateTime: schedule.forecastedFinishDateTime,
        };
      }
      return forecastByItemId;
    }

    const forecastByItemId: Record<number, DependencyForecastDates> = {};
    for (const [itemId, schedule] of Object.entries(schedules ?? {})) {
      forecastByItemId[Number(itemId)] = {
        forecastedStartDateTime: schedule.forecastedStartDateTime,
        forecastedFinishDateTime: schedule.forecastedFinishDateTime,
      };
    }
    return forecastByItemId;
  }, [scenarioContext, scenarioSchedules, schedules]);
};
